const init = (wrapper) => {
  const button = wrapper.querySelector('.js-image-content-button')
  const contentMore = wrapper.querySelector('.js-image-content-content-more')

  if (button) {
    button.addEventListener('click', () => {
      wrapper.classList.toggle('is-expanded')
      button.setAtrribute('aria-expanded', wrapper.classList.has('is-expanded'))
    })
  }

  if (contentMore) {
    const contentMoreInner = contentMore.querySelector('.js-image-content-content-more-inner')
    const updateMaxHeight = () => {
      wrapper.style.setProperty('--content-more-height', `${contentMoreInner.offsetHeight}px`)
    }

    updateMaxHeight()
    window.addEventListener('resize', updateMaxHeight)
  }
}

export default () => {
  document.querySelectorAll('.js-image-content').forEach((wrapper) => {
    if (!wrapper.classList.contains('is-initialized')) {
      wrapper.classList.add('is-initialized')
      init(wrapper)
    }
  })
}
